import { FC } from 'react';

import StarIcon from '@mui/icons-material/Star';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const ServicesCard: FC = () => (
  <ToolCard
    icon={<StarIcon fontSize="large" />}
    title="Papildomos paslaugos"
    description="Redaguokite papildomas paslaugas varotojai gali papildomai užsakyti pirkadmi keliones, draudimo paslaugos, pervežimas iš oro uosto ir t.t."
    action={
      <Button href="service-groups" startIcon={<StarIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default ServicesCard;
